import { gql } from '@apollo/client/core';

export const downloadItemFragment = gql`
  fragment DownloadItemFields on DownloadItem {
    entryTitle
    downloadItemText {
      ...RichTextBlockFields
    }
    buttonText
    isExternal
    file {
      url
    }
    fileUrl
  }
`;

export const downloadsBlockFragment = gql`
  fragment DownloadsBlockFields on DownloadsBlock {
    entryTitle
    downloadsTitle
    downloadsText
    blocksCollection(limit: 10) {
      items {
        ...DownloadItemFields
      }
    }
  }
  ${downloadItemFragment}
`;
